//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Tabs from '@/components/Tabs';
import { mapGetters } from 'vuex';
import Tips from '@/components/Tips';
import Vlogin from '../../components/popUp';
import Noresult from '@/components/Noresult';
import api from '../../api';

export default {
    components: { Tips, Tabs, Noresult, Vlogin },
    // beforeRouteEnter: (to, from, next) => {
    //     next((vm) => {

    //     });
    // },
    data: () => ({
        tabsDatas: [
            { text: '全部', key: 'all' },
            { text: '进行中', key: 'doing' },
            { text: '已完成', key: 'completed' },
        ],
        type: 'all',
        tenderList: [],
    }),
    mounted() {
        if (this.isUpper && this.isLogin) {
            this.$vux.toast.text('您不是车队, 不能访问此页面');
            this.$router.push({
                name: 'mineIndex',
            })
        }
        if (this.$route.query.type) {
            this.type = this.$route.query.type;
        }
        this.getList(this.type);
    },
    computed: {
        allDic() {
            return this.$store.state.allDic;
        },
        ...mapGetters([
            'isLower',
            'isUpper',
        ]),
        isLogin() {
            return this.$store.state.isLogin;
        },
    },
    methods: {
        tabClick(activeKey) {
            this.getList(activeKey);
        },
        toDetail(id) {
            this.$router.push({
                path: '/tenderingL/detail',
                query: {
                    id,
                }
            });
        },
        goodsType(type) {
            let goodsType = '--';
            if (this.allDic['goodsType']) {
                this.allDic['goodsType'].children.map((item) => {
                    if (`${type}` === item.id) {
                        goodsType = item.value;
                    }
                    return item;
                })
            }
            return goodsType;
        },
        getList(key) {
            let param = {
                page: 1,
                size: 100,
                currentStage: '',
                currentState: '',
            };
            if (key === 'doing') {
                param = {
                    page: 1,
                    size: 100,
                    currentStateArray: [1,2,3,4],
                }
            }
            if (key === 'completed') {
                param = {
                    page: 1,
                    size: 100,
                    currentStage: 30,
                    currentState: 6,
                }
            }
            api.vega.tender.ManagerList(param).then((res) => {
                const data = res.data.data;
                this.tenderList = data.list;
            })
        },
        nowStateLow(state, rounds, stage) { // 状态机
            let r = '第一轮报价';
            let t = '已报名';
            let c = 'status_warning';
            switch (rounds) {
                case 2:
                    r = '第二轮报价';
                    break;
                case 3:
                    r = '第三轮报价';
                    break;
                default:
                    r = '第一轮报价';
                    break;
            }
            if (stage === 10) { // 报名阶段
                switch (state) {
                    case 3:
                        t = '已报名';
                        c = 'status_danger';
                        break;
                    case 5:
                        t = '报名未通过';
                        c = 'status_danger';
                        break;
                    case 8:
                        t = '已关闭';
                        c = 'status_info';
                        break;
                    default:
                        t = '已报名';
                        c = 'status_danger';
                        break;
                }
            } else if (stage === 20) { // 邀标应标阶段
                switch (state) {
                    case 1:
                        t = '待应标';
                        c = 'status_warning';
                        break;
                    case 2:
                        t = '未应标';
                        c = 'status_info';
                        break;
                    case 3:
                        t = '已应标';
                        c = 'status_danger';
                        break;
                    case 5:
                        t = '应标未通过';
                        c = 'status_danger';
                        break;
                    case 8:
                        t = '已关闭';
                        c = 'status_info';
                        break;
                    default:
                        t = '待应标';
                        c = 'status_warning';
                        break;
                }
            } else if (stage === 30) { // 投标阶段
                switch (state) {
                    case 1:
                        t = '待投标';
                        c = 'status_warning';
                        break;
                    case 2:
                        t = '未投标';
                        c = 'status_info';
                        break;
                    case 3:
                        t = '已投标';
                        c = 'status_danger';
                        break;
                    case 5:
                        t = '未中标';
                        c = 'status_info';
                        break;
                    case 6:
                        t = '已中标';
                        c = 'status_danger';
                        break;
                    case 7:
                        t = '未中标';
                        c = 'status_info';
                        break;
                    default:
                        t = '待投标';
                        c = 'status_warning';
                        break;
                }
            }
            return {
                r,
                t,
                c,
            };
        },
        nowStateLowImg(state, rounds, stage) { // 状态机
            let t = require('../../assets/images/ybmdsh@3x.png');
            if (stage === 10) { // 报名阶段
                switch (state) {
                    case 3:
                        t = require('../../assets/images/ybmdsh@3x.png');
                        break;
                    case 5:
                        t = require('../../assets/images/bmwtg@3x.png');
                        break;
                    case 8:
                        t = require('../../assets/images/closed@3x.png');
                        break;
                    default:
                        t = require('../../assets/images/ybmdsh@3x.png');
                        break;
                }
            } else if (stage === 20) { // 邀标应标阶段
                switch (state) {
                    case 1:
                        t = require('../../assets/images/dyb@3x.png');
                        break;
                    case 2:
                        t = require('../../assets/images/wyb@3x.png');
                        break;
                    case 3:
                        t = require('../../assets/images/yybdsh@3x.png');
                        break;
                    case 5:
                        t = require('../../assets/images/no-pass@3x.png');
                        break;
                    case 8:
                        t = require('../../assets/images/closed@3x.png');
                        break;
                    default:
                        t = require('../../assets/images/dyb@3x.png');
                        break;
                }
            } else if (stage === 30) { // 投标阶段
                switch (state) {
                    case 1:
                        t = require('../../assets/images/dtb@3x.png');
                        break;
                    case 2:
                        t = require('../../assets/images/wtb@3x.png');
                        break;
                    case 3:
                        t = require('../../assets/images/ytbdsh@3x.png');
                        break;
                    case 5:
                        t = require('../../assets/images/wzb@3x.png');
                        break;
                    case 6:
                        t = require('../../assets/images/yzb@3x.png');
                        break;
                    case 7:
                        t = require('../../assets/images/wzb@3x.png');
                        break;
                    default:
                        t = require('../../assets/images/dtb@3x.png');
                        break;
                }
            }
            return t;
        },
    },
};
